export const SEARCH_OVERSEAS_ON_LOAD = 'search_overseas/on_load';
export const searchOverseasOnLoad = () => ({
  type: SEARCH_OVERSEAS_ON_LOAD
});

export const SEARCH_OVERSEAS_ON_LOAD_SUCCESS = 'search_overseas/on_load_success';
export const searchOverseasOnLoadSuccess = data => ({
  type: SEARCH_OVERSEAS_ON_LOAD_SUCCESS,
  payload: data
});

export const SEARCH_OVERSEAS_FILTER = 'search_overseas/filter';
export const searchOverseasFilter = data => ({
  type: SEARCH_OVERSEAS_FILTER,
  payload: data
});

export const SEARCH_OVERSEAS_FILTER_SUCCESS = 'search_overseas/filter_success';
export const searchOverseasFilterSuccess = data => ({
  type: SEARCH_OVERSEAS_FILTER_SUCCESS,
  payload: data
});

export const SEARCH_OVERSEAS_RESET = 'search_overseas/reset';
export const searchOverseasReset = () => ({
  type: SEARCH_OVERSEAS_RESET
});

export const SEARCH_OVERSEAS_DETAILS = 'search_overseas/details';
export const searchOverseasDetails = data => ({
  type: SEARCH_OVERSEAS_DETAILS,
  payload: data
});

export const SEARCH_OVERSEAS_DETAILS_SUCCESS = 'search_overseas/details_success';
export const searchOverseasDetailsSuccess = data => ({
  type: SEARCH_OVERSEAS_DETAILS_SUCCESS,
  payload: data
});

export const SEARCH_OVERSEAS_DETAILS_RESET = 'search_overseas/details_reset';
export const searchOverseasDetailsReset = () => ({
  type: SEARCH_OVERSEAS_DETAILS_RESET
});
